import React, { useEffect, useState } from 'react';
import { HomeWrapper } from '../../../src/components/HomePage/HomeBanner/styled';
import NewFooter from '../../../src/components/HomePage/NewFooter';
import NewHeader from '../../../src/components/HomePage/NewHeader';
import VaccinationToolIndex from '../../../src/components/VaccinationTool';
import VaccinationHead from '../../../src/components/VaccinationTool/VaccinationHead';
import GlobalStyle from '../../../src/styles/globalStylesV2';
import {
  androidDisablePullRefresh,
  enableAndroidBack,
  hideAndroidBottomBar,
  hideAndroidTopBar,
} from '../../../src/Utils/androidUtils';
import { isAndroidAppUser, isIOSAppUser } from '../../../src/Utils/helper';
import { iosHideTopBar } from '../../../src/Utils/IosUtils';
import { NextSeo } from 'next-seo';

export default function VaccinationTool() {
  const [hideHamIcon, setShowHamIcon] = useState(false);
  const [showIconForIos, setShowIconForIos] = useState(false);
  useEffect(() => {
    if (isAndroidAppUser()) {
      hideAndroidTopBar();
      enableAndroidBack(true);
      hideAndroidBottomBar();
      androidDisablePullRefresh();
      setShowHamIcon(true);
    }
    if (isIOSAppUser()) {
      iosHideTopBar();
      setShowHamIcon(true);
      setShowIconForIos(true);
    }
  }, []);
  const metaTitle = 'Vaccination Tracker Tool for Your Baby | MyloFamily';
  const metaDescription =
    "Keep a track of our baby's vaccination schedule & never miss a vaccine with our vaccination tracker tool.";
  return (
    <>
      <VaccinationHead />
      <GlobalStyle />
      <NextSeo title={metaTitle} description={metaDescription} />
      {!hideHamIcon && (
        <NewHeader
          showCart={false}
          showTrackOrder={false}
          hideLogin={true}
          hideMobileSearch={true}
          hideHamIcon={showIconForIos}
          nostrip={true}
        />
      )}
      <HomeWrapper hidePaddingForAndroid={hideHamIcon}>
        <VaccinationToolIndex />
      </HomeWrapper>

      {!hideHamIcon && <NewFooter />}
    </>
  );
}
